import React from 'react';
import PropTypes from 'prop-types';
import NotificacaoItem from './NotificacaoItem';

const propTypes = {
  dataSource: PropTypes.arrayOf(PropTypes.shape({})),
};

const defaultProps = {
  dataSource: [],
};

const NotificacaoItemList = ({ dataSource }) => {
  return dataSource.map(notificacao => (
    <React.Fragment key={notificacao.id}>
      <li>
        <NotificacaoItem item={notificacao} />
      </li>
      <li className="dropdown-divider m-0 bt-grey" />
    </React.Fragment>
  ));
};
NotificacaoItemList.propTypes = propTypes;
NotificacaoItemList.defaultProps = defaultProps;

export default NotificacaoItemList;
